import * as React from "react";
import { observer } from "mobx-react-lite";
import { calculateFormula } from "src/common/formula/calculateFormula";
import { FormulaCommand } from "src/common/formula/FormulaCommand";
import { Sheet2Store } from "src/components/Sheet2/Sheet2Store";
import { debounce, DebounceCounter } from "src/common/debounce";
import { Input } from "antd";
import { ZBom3PosRow } from "../ZBom3Position";

type PropsCell2FormulaView = {
  sheetStore: Sheet2Store;
  cmdList: FormulaCommand[];
  attr2cell: Record<string, string>;
  precision?: number | null;
  row: ZBom3PosRow;
  update?: (value: string) => void; // отсутствует, если у пользователя нет прав
  addonBefore?: React.ReactNode;
  addonAfter?: React.ReactNode;
};

export const Cell2FormulaView: React.FC<PropsCell2FormulaView> = observer(
  (props) => {
    const {
      sheetStore,
      cmdList,
      attr2cell,
      precision,
      row,
      update,
      addonBefore,
      addonAfter,
    } = props;
    const deb = React.useRef<DebounceCounter>({});
    let text: string = "";
    try {
      const { cellCurValues } = sheetStore;
      const vars: Record<string, number> = {};
      Object.entries(attr2cell).forEach(([attrId, cellId]) => {
        // LPLM-5296 В формулах могут использоваться динамически меняемые ячейки и статические
        // динамические извлекаются из sheetStore, статические - из строки
        const cellValue =
          cellId in cellCurValues
            ? cellCurValues[cellId]
            : row.attributes[attrId]?.value;
        const numValue = parseFloat(cellValue as string);
        if (!Number.isNaN(numValue)) vars[attrId] = numValue;
      });
      const value = calculateFormula(cmdList, vars);

      // update здесь нужен, чтобы отсылать на сервер результаты вычисления формулы.
      // Есть подозрение, что могут происходить ненужные запросы.
      // Но это лучше исследовать в рамках отдельной задачи.
      if (update) {
        debounce(deb.current, 1000, () => update(value.toString()));
      }

      text =
        typeof precision === "number"
          ? value.toFixed(precision)
          : value?.toString();
    } catch (_) {
      update?.("~");
    }
    // Используется Input а Cell2ReadonlyText не потому что нужны аддоны
    // disabled - добавляет серый фон, иначе ячейка выглядит как редактируемая и это
    // и на сером фоне текст должен выглядеть чётко. поэтому в явном виде указан чёрный цвет
    return (
      <Input
        value={text}
        readOnly
        disabled
        addonBefore={addonBefore}
        addonAfter={addonAfter}
        style={{ color: "black" }}
      />
    );
  },
);
